import { useEffect, useState } from "react";
import { getDeviceType } from "../utils/user_agent";
import "../../stylesheets/chat_page.css";

const APP_STORE_URL = "https://apps.apple.com/us/app/incite-ai/id6476565263";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.inciteai.app&pcampaignid=web_share";
const STORE_URL_BY_DEVICE = {
  ios: APP_STORE_URL,
  android: PLAY_STORE_URL,
};
const DISMISS_KEY = "downloadAppBannerDismissed";

const DownloadAppBanner = () => {
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);
  const [storeUrl, setStoreUrl] = useState(null);

  useEffect(() => {
    const isStandalone =
      window.navigator.standalone ||
      window.matchMedia("(display-mode: standalone)").matches;

    const deviceType = getDeviceType();
    const androidDeepLinkActive =
      ((typeof window !== "undefined" && window.globals) || {})
        .android_deep_link_active === "true";
    if (deviceType === "android" && !androidDeepLinkActive) return;

    const url = STORE_URL_BY_DEVICE[deviceType];
    if (!url || isStandalone) return;
    if (sessionStorage.getItem(DISMISS_KEY)) return;

    setStoreUrl(url);
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setClosing(true);
    setTimeout(() => setVisible(false), 300);
  };

  if (!visible) return null;

  return (
    <div
      className={`download-app-banner${
        closing ? " download-app-banner--closing" : ""
      }`}
    >
      <button
        className="download-app-banner__close"
        aria-label="Dismiss"
        onClick={dismiss}
      >
        ×
      </button>
      <img
        className="download-app-banner__icon"
        src="/apple-touch-icon.png"
        alt="Incite AI"
      />
      <div className="download-app-banner__text">
        <span className="download-app-banner__title">Incite AI</span>
        <span className="download-app-banner__subtitle">
          Get the full experience in the app
        </span>
      </div>
      <a
        className="download-app-banner__cta"
        href={storeUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={dismiss}
      >
        Get
      </a>
    </div>
  );
};

export default DownloadAppBanner;
